import React from "react";
import styled from "styled-components";
import tw from "twin.macro";
import { useTranslation } from "react-i18next";

import DesktopBannerImage from "images/imgbg.png";

const HeroSection = styled.div`
  ${tw`flex`}
  width: 100vw;
  min-height: 320px;
  flex-direction: row;
  margin-left: -30px !important;
  padding: 0 !important;
  overflow: hidden;

  @media (max-width: 768px) {
    flex-direction: column;
    margin-left: 0;
    width: 100vw;
  }
`;

const Content = styled.div`
  ${tw`flex flex-col items-center justify-center`}
  width: 50%;
  min-height: 320px;
  background: #eee8e7;
  padding: 3rem 2rem;
  text-align: center;

  @media (max-width: 768px) {
    width: 100vw;
    padding: 2rem 0;
  }
`;

const Heading = styled.h1`
  ${tw`font-black text-xl md:text-3xl text-black mb-6`}
  letter-spacing: 0.1em;
`;

const SubText = styled.p`
  ${tw`text-black text-base md:text-lg mb-4`}
`;

const PrimaryButton = styled.a`
  ${tw`px-8 py-3 rounded font-bold mt-4`}
  background: transparent;
  border: 2px solid #357a4d;
  color: #357a4d;

  &:hover {
    background: #357a4d;
    color: #fff;
  }
`;

const ImageColumn = styled.div`
  ${tw`flex items-center justify-center`}
  width: 50%;
  min-height: 320px;
  background: #fff;

  @media (max-width: 768px) {
    width: 100%;
    min-height: 200px;
  }
`;

const ResponsiveImage = styled.img`
  width: 100%;
  height: auto;
  object-fit: cover;
`;

const Hero = ({ primaryButtonUrl = "/Boutique" }) => {
  const { t } = useTranslation(); // ✅ CORRECT PLACE

  return (
    <HeroSection>
      <Content>
        <Heading>{t("hero.title")}</Heading>
        <SubText>{t("hero.description")}</SubText>
        <PrimaryButton href={primaryButtonUrl}>
          {t("hero.button")}
        </PrimaryButton>
      </Content>

      <ImageColumn>
        <ResponsiveImage src={DesktopBannerImage} alt="Hero Banner" />
      </ImageColumn>
    </HeroSection>
  );
};

export default Hero;
